(function() {
    "use strict";

    angular.module("eSign")
        .controller("LogoutController", ['$scope', '$window', 'sessionService', 'appConfig', function($scope, $window, sessionService, appConfig) {

            $scope.logout = function() {
                sessionService.logout().then(function (response) {
					sessionService.getSettings().then(function (response) {
						if (response.data.logoutLandingPage) {
                            $window.location.href = response.data.logoutLandingPage;
                        } else {
                            $window.location.href = '/';
                        }
                    });
                });
            }

            $scope.goBack = function () {
                $window.location.href = appConfig.chooseSignTaskUrl;
            };

            $scope.isSignedIn = false;
            $scope.hasMoreSignTasks = false;

            var checkMoreSignTasks = function() {
                sessionService.NumberOfSignTasks().then(function (response) {
	                $scope.hasMoreSignTasks = response.data > 1;
                });
            }

            var checkIfSignedIn = function () {
                sessionService.isSignedIn().then(function(response) {
                    $scope.isSignedIn = response.data;
                });
                checkMoreSignTasks();
            };

            checkIfSignedIn();
        }]);
}());
